import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import { merge, Subscription } from 'rxjs';
import { Swiper } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

declare module 'swiper' {
    interface Swiper {
        snapIndex: number;
    }
}

/**
 * TODO: rewrite to carousel ref if the carousel will be changed to swiper
 *
 * @example
 * <carousel #carouselRef></carousel>
 *
 * <carousel-dots [carouselRef]="carouselRef"></carousel-dots>
 */
@Component({
    selector: 'carousel-dots',
    templateUrl: './carousel-dots.component.html',
    styleUrls: ['./carousel-dots.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarouselDotsComponent implements OnChanges, OnDestroy {
    @Input()
    carouselRef?: SwiperComponent;

    @Input()
    paginationClass?: string;

    swiper?: Swiper;
    index?: number;

    private swiperSubscription?: Subscription;

    constructor(protected changeDetectorRef: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['carouselRef']) {
            this.update();
        }
    }

    ngOnDestroy(): void {
        this.swiperSubscription?.unsubscribe();
    }

    get bullets() {
        return this.swiper?.pagination.bullets || [];
    }

    slideTo(index = 0) {
        const swiper = this.carouselRef?.swiperRef;
        const slidesPerGroup = swiper?.params.slidesPerGroup || 1;
        const loop = swiper?.params.loop || false;
        let slideTo = index * slidesPerGroup;

        if (loop) {
            slideTo += swiper?.loopedSlides || 0;
        }

        this.swiper?.slideTo(slideTo);
    }

    protected update() {
        if (this.carouselRef) {
            this.swiperSubscription?.unsubscribe();

            this.swiperSubscription = merge(this.carouselRef.s_swiper, this.carouselRef.s_slideChange).subscribe(() => this.onUpdate());
        }
    }

    protected onUpdate() {
        const slidesPerGroup = this.carouselRef?.slidesPerGroup || 1;

        this.swiper = this.carouselRef?.swiperRef;
        this.index = slidesPerGroup > 1 ? this.swiper?.snapIndex : this.swiper?.realIndex;

        this.changeDetectorRef.detectChanges();
    }

    protected trackByIndex(index: number) {
        return index;
    }
}
